<template>
  <v-card ref="form" class="mx-auto mt-5" max-width="500" v-if="selfindex !== null">
    <v-toolbar>
      <v-toolbar-title>Questionnaire</v-toolbar-title>
      <v-spacer></v-spacer>
      <span>id: {{formID}}</span>
      <v-spacer></v-spacer>
      <v-progress-circular :color="progressColor" :value="progress" class="mr-2">
        <v-icon v-if="step === finalStep" color="green">check</v-icon>
      </v-progress-circular>
    </v-toolbar>
    <v-snackbar v-model="snackbar" :top="true" :multi-line="true" :timeout="4000" color="error">
      {{ errorText }}
      <v-btn color="white" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card-title class="title font-weight-regular justify-space-between">
      <span>{{ currentTitle }}</span>
    </v-card-title>
    <v-window v-model="step">
      <v-window-item :value="1">
        <div class="pa-3 text-center">
          <v-img
            class="mb-3"
            contain
            height="80"
            src="https://firebasestorage.googleapis.com/v0/b/gsf-rgs.appspot.com/o/icons8-treatment-64.png?alt=media&token=7f1dff34-c5ed-4136-8250-ed3dbbf6da37"
          ></v-img>
          <h3 class="title font-weight-light mb-2">Welcome!</h3>
          <span>Let’s begin with {{formTypeName[0]}} medical information.</span>
        </div>
      </v-window-item>

      <v-window-item :value="2">
        <v-card-text>
          <v-text-field  v-model="dataModel[selfindex].fname" label="First Name"></v-text-field>
          <v-text-field  v-model="dataModel[selfindex].lname" label="Last Name"></v-text-field>
        </v-card-text>
      </v-window-item>

      <v-window-item :value="3">
        <v-card-text>
          <v-radio-group v-model="dataModel[selfindex].gender">
            <v-radio v-for="n in genderList" :key="n" :label="`${n}`" :value="n"></v-radio>
          </v-radio-group>
        </v-card-text>
      </v-window-item>

      <v-window-item :value="4">
        <v-card-text>
          <v-radio-group
            v-model="dataModel[selfindex].isLiving"
            true-value="true"
            false-value="false"
          >
            <v-radio label="Yes" :value="true"></v-radio>
            <v-radio label="No" :value="false"></v-radio>
          </v-radio-group>
        </v-card-text>
      </v-window-item>

      <v-window-item :value="5">
        <template>
        <v-form v-model="formValid" lazy-validation ref="ageForm">
        <v-card-text>
          <v-text-field
            required
            @focus="$event.target.select()"
            type="tel"
            pattern="[0-9]*"
            :rules='ageRules'
            v-model="dataModel[selfindex].age"
            hint="for patient < 1 years old, use decimal point ex: 11 months old use 0.11"
            label="Age"
          ></v-text-field>
        </v-card-text>
        </v-form>
        </template>
      </v-window-item>

      <v-window-item :value="cancerStep">
        <Cancer v-if='step == cancerStep' :modifyIndex="selfindex"/>
      </v-window-item>

      <v-window-item :value="geneTestStep">
        <CancerTest v-if='step == geneTestStep' :modifyIndex="selfindex"/>
      </v-window-item>

      <v-window-item :value="8">
        <v-card-text>
          <v-textarea
            v-model="dataModel[selfindex].notes"
            outline
            name="input-7-4"
            label="Additional pertinent information."
            value
          ></v-textarea>
        </v-card-text>
      </v-window-item>

      <v-window-item :value="9">
        <div class="pa-3 text-center">
          <v-img
            class="mb-3"
            contain
            height="96"
            src="https://firebasestorage.googleapis.com/v0/b/gsf-rgs.appspot.com/o/genealogy.png?alt=media&token=49afc80c-b30b-4721-b5ca-4ba3df3b4ee7"
          ></v-img>
          <h3 class="title font-weight-light mb-2">Family</h3>
          <h4>Thank you!</h4>
          <span>We will now collect {{formTypeName[0]}} family history information.</span>
        </div>
      </v-window-item>

      <v-window-item :value="chilStep">
        <keep-alive>
        <Relative  :formType='formTypeName' v-if='step == chilStep' personType="child"/>
        </keep-alive>
      </v-window-item>

      <v-window-item :value="sibStep">
        <keep-alive>
        <Relative :formType='formTypeName' v-if='step == sibStep' personType="sibling"/>
        </keep-alive>
      </v-window-item>
        
      <v-window-item  :value="sibStep+1">

          <v-card-text v-if='sibNum("sibling") == 0' >
            <h5 class="title font-weight-light mb-2"><v-icon>warning</v-icon> {{formTypeName[1]}} have not yet entered any sibling info</h5>
          </v-card-text>
        <keep-alive>
        <Relative :formType='formTypeName' v-if='step == sibStep+1' :sibNum='sibNum("sibling")' personType="niece/nephew"/>
        </keep-alive>
      </v-window-item>
        

      <v-window-item :value="sibStep+2">
        <div class="pa-3 text-center">
          <img
            class="mb-3"
            contain
            height="64"
            src="https://firebasestorage.googleapis.com/v0/b/gsf-rgs.appspot.com/o/icons8-woman-64.png?alt=media&token=0aa0a8cf-3c03-4e27-b14f-8bd3042f9691"
          >
          <img
            class="mb-3"
            contain
            height="64"
            src="https://firebasestorage.googleapis.com/v0/b/gsf-rgs.appspot.com/o/genealogy.png?alt=media&token=49afc80c-b30b-4721-b5ca-4ba3df3b4ee7"
          >

          <h3 class="title font-weight-light mb-2">Mother's family</h3>
          <h4>Thank you!</h4>
          <span>Now we will focus on {{formTypeName[0]}} maternal side of the family.</span>
        </div>
      </v-window-item>

      <v-window-item :value="sibStep+3">
        <keep-alive>
        <singleRelative :formType='formTypeName'  v-if='step == sibStep+3' :modifyIndex="momindex" relativeName="mother"/>
        </keep-alive>
      </v-window-item>
      <v-window-item :value="sibStep+4">
        <keep-alive>
        <Relative :formType='formTypeName' v-if='step == sibStep+4' personType="maternal aunt"/>
        </keep-alive>
      </v-window-item>
      <v-window-item :value="sibStep+5">
        <keep-alive>
        <Relative :formType='formTypeName' v-if='step == sibStep+5' personType="maternal uncle"/>
        </keep-alive>
      </v-window-item>

        <v-window-item :value="sibStep+6">

              <v-card-text v-if='sibNum("maternal cousins") == 0' >
            <h5 class="title font-weight-light mb-2"><v-icon>warning</v-icon> {{formTypeName[1]}} have not yet entered any info for maternal uncles/aunts</h5>
          </v-card-text>
          <keep-alive>
      <Relative :formType='formTypeName' v-if='step == sibStep+6' :sibNum='sibNum("maternal cousins")' personType="maternal cousins"/>
          </keep-alive>
       
      </v-window-item>

      <v-window-item :value="sibStep+7">
        <keep-alive>
        <singleRelative :formType='formTypeName'  v-if='step == sibStep+7'
          :modifyIndex="maternalGrandfatherIndex"
          relativeName="maternal grandfather"
        />
        </keep-alive>
      </v-window-item>
      <v-window-item :value="sibStep+8">
        <keep-alive>
        <singleRelative :formType='formTypeName'  v-if='step == sibStep+8'
          :modifyIndex="maternalGrandmotherIndex"
          relativeName="maternal grandmother"
        />
        </keep-alive>
      </v-window-item>
      <v-window-item :value="sibStep+9">
        <div class="pa-3 text-center">
          <img
            class="mb-3"
            contain
            height="64"
            src="https://firebasestorage.googleapis.com/v0/b/gsf-rgs.appspot.com/o/icons8-standing-man-64.png?alt=media&token=f127df48-f9a4-409a-872e-350ff6194437"
          >
          <img
            class="mb-3"
            contain
            height="64"
            src="https://firebasestorage.googleapis.com/v0/b/gsf-rgs.appspot.com/o/genealogy.png?alt=media&token=49afc80c-b30b-4721-b5ca-4ba3df3b4ee7"
          >

          <h3 class="title font-weight-light mb-2">Father's family</h3>
          <span>we will now collect {{formTypeName[0]}} father's family info</span>
        </div>
      </v-window-item>
      <v-window-item :value="sibStep+10">
        <keep-alive>
        <singleRelative :formType='formTypeName'  v-if='step == sibStep+10' :modifyIndex="dadindex" relativeName="patient's father"/>
        </keep-alive>
      </v-window-item>
      <v-window-item :value="sibStep+11">
        <keep-alive>
        <Relative :formType='formTypeName' v-if='step == sibStep+11' personType="paternal aunt"/>
        </keep-alive>
      </v-window-item>
      <v-window-item :value="sibStep+12">
        <keep-alive>
        <Relative :formType='formTypeName' v-if='step == sibStep+12' personType="paternal uncle"/>
        </keep-alive>
      </v-window-item>
      <v-window-item :value="sibStep+13">

              <v-card-text v-if='sibNum("paternal cousins") == 0' >
            <h5 class="title font-weight-light mb-2"><v-icon>warning</v-icon> {{formTypeName[1]}} have not yet entered any info for paternal uncles/aunts</h5>
          </v-card-text>
          <keep-alive>
      <Relative :formType='formTypeName' v-if='step == sibStep+13' :sibNum='sibNum("paternal cousins")' personType="paternal cousins"/>
          </keep-alive>
       
      </v-window-item>
      <v-window-item :value="sibStep+14">
        <keep-alive>
        <singleRelative :formType='formTypeName'  v-if='step == sibStep+14'
          :modifyIndex="paternalGrandmotherIndex"
          relativeName="paternal grandmother"
        /> 
        </keep-alive>       
      </v-window-item>
           <v-window-item  :value="sibStep+15">
            <keep-alive>
         <singleRelative :formType='formTypeName'  v-if='step == sibStep+15'
          :modifyIndex="paternalGrandfatherIndex"
          relativeName="paternal grandfather"
        />
        </keep-alive>
      </v-window-item>

      <v-window-item :value="finalStep-1">
        <Review v-if="step=== finalStep-1"/>
      </v-window-item>

      <v-window-item :value="finalStep">
        <div class="pa-3 text-center">
          <v-img
            class="mb-3"
            contain
            height="64"
            src="https://firebasestorage.googleapis.com/v0/b/gsf-rgs.appspot.com/o/task-completed.png?alt=media&token=b09bf984-16b2-44a0-beeb-cb3532e5edab"
          ></v-img>
          <h3 class="title font-weight-light mb-2">Thank you</h3>
          <span class="caption grey--text">a genetic counselor will review your family history soon.</span>
          <Pdf />
        </div>
      </v-window-item>
    </v-window>

    <v-divider></v-divider>

    <v-card-actions>
      <v-btn :disabled="step === 1 || step === finalStep+5 ||!formValid" text @click="step--">Back</v-btn>
      <v-spacer></v-spacer>

      <v-btn
        v-if="step < finalStep-1 && complete === true"
        color="info"
        depressed
        
        @click="step = finalStep-1"
      >Jump to Review</v-btn>

      <v-spacer></v-spacer>
      <v-btn
        v-if="step !== finalStep"
        color="primary"
        depressed
          :disabled="!formValid"
        @click="stepValidate"
      >{{buttonText}}</v-btn>
    </v-card-actions>
  </v-card>
</template>



<script>
import { mapFields } from "vuex-map-fields";
import Review from "../../components/questionnaire/PatientFormComp/Review";
import Cancer from "../../components/questionnaire/PatientFormComp/Cancer.vue";
import SingleRelative from "../../components/questionnaire/PatientFormComp/SingleRelative.vue";
import Relative from "../../components/questionnaire/PatientFormComp/Relative.vue";
import CancerTest from "../../components/questionnaire/PatientFormComp/CancerTest.vue";
import Pdf from '../../components/questionnaire/Pdf'
import { 
  mapValues, 
  isString, 
  isNumber, 
  isArray, 
  isNull, 
  isBoolean, 
  isObject, 
  isDate 
} from 'lodash';

export default {
  props : {
    formType : String
  },
  components: {
    Cancer,
    SingleRelative,
    Relative,
    CancerTest,
    Review,
    Pdf
  },
  data: () => ({
    ageRules: [v => (v && v >= 0) || 'Age must be larger or equal to 0'],
     items: [
        {
          text: 'Questionnaire Home',
          disabled: false,
          href: '/questionnaire'
        },
        {
          text: 'Questionnaire',
          disabled: true,
          href: 'prvoiderform'
        }
      ],
    formTypeName : ["the patient’s","patient","Has the patient","Is the patient","does the patient have"],
    selfindex: null,
    maternalGrandfatherIndex: null,
    maternalGrandmotherIndex: null,
    paternalGrandfatherIndex: null,
    paternalGrandmotherIndex: null,
    momindex: null,
    dadindex: null,
    cancerStep: 6,
    geneTestStep: 7,
    chilStep: 10,
    sibStep: 11,
    finalStep: 28,
    complete: false,
    active: true,
    step: 1,
    encodeddata : null
  }),

  methods: {
        saveDatatoDB(){   
          this.encodeddata = this.firestoreMap(this.dataModel) 
          this.encodeddata = Object.keys(this.encodeddata).map((key) =>{
            return  this.encodeddata[key];
          });  
        const url = 'https://firestore.googleapis.com/v1beta1/projects/dynamo-243419/databases/(default)/documents/users/'+this.user.uid+'?updateMask.fieldPaths=qData'
        const body = {
            "fields": {
                  "qData": {
                  "arrayValue": {
                    "values" : this.encodeddata
                  }
                  }
                }
              }
        const headers = {headers : {Authorization: "Bearer " + this.user.idToken}}
    this.$axios
      .patch(url,body,headers)
      .then(response => { 
        if(response.status === 200)
         this.snackBarType = "success"    
          this.snackBarshow =true; 
          this.snackBarmessage = "Record saved";
      })
      .catch(()=> {
          this.snackBarType = "warning"    
          this.snackBarshow =true; 
          this.snackBarmessage = "Operation failed, please check your network connection and try again";
          })
    },
    
          firestoreMap(data) {
          return mapValues(data, (v) => {
            if (isString(v))
                return { "stringValue": v }

            if (isNumber(v))
                return { "integerValue": v }

            if (isNull(v))
                return { "nullValue": v }

            if (isDate(v))
                return { "timestampValue": v }

            if (isBoolean(v))
                return { "booleanValue": v }

            if (isObject(v))
                return { "mapValue": { "fields": this.firestoreMap(v) } }

            if (isArray(v))
                return { "arrayValue": { "values": this.firestoreMap(v) } }

            return { "stringValue": "UNABLE TO MAP VALUE" }
          });
        },
    sibNum(type){
      if(type === "maternal cousins"){
        var mUncle = this.dataModel.filter(item=> {return item.relationship === "maternal uncle"}).length
        var mAunt = this.dataModel.filter(item=> {return item.relationship === "maternal aunt"}).length
         return mUncle + mAunt 
      }else if(type === "paternal cousins"){
         var pUncle = this.dataModel.filter(item=> {return item.relationship === "paternal uncle"}).length
        var pAunt = this.dataModel.filter(item=> {return item.relationship === "paternal aunt"}).length
        return pUncle + pAunt
      }else{
        var sibs = this.dataModel.filter(item=> {return item.relationship === type}).length
        return sibs
      }
       
    },
    genID() {
      var ALPHABET =
        "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

      var ID_LENGTH = 8;

      var generate = function() {
        var rtn = "";
        for (var i = 0; i < ID_LENGTH; i++) {
          rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
        }
        return rtn;
      };
      return generate();
    },
    stepValidate() {
      switch (this.step) {
        case 2:
          if (this.dataModel[this.selfindex].fname === "") {
            this.snackbar = true;
            this.errorText = "Please enter first name";
            return;
          } else if(this.dataModel[this.selfindex].lname === ""){
            this.snackbar = true;
            this.errorText = "Please enter last name";
            return;
          }
          else{
            this.dataModel[this.selfindex].name = this.dataModel[this.selfindex].fname + " "+ this.dataModel[this.selfindex].lname
            this.step++;
            return;
          }
        case 5:
          if (
            isNaN(this.dataModel[this.selfindex].age) ||
            this.dataModel[this.selfindex].age === ""
          ) {
            this.snackbar = true;
            this.errorText = "Age can only be numeric value and cant be empty";
            return;
          } else {
            this.step++;
            return;
          }
        case 3:
          if (this.dataModel[this.selfindex].gender === "") {
            this.snackbar = true;
            this.errorText = "Please select gender";
            return;
          } else {
            this.step++;
            return;
          }
        case this.cancerStep:
          if (
            this.dataModel[this.selfindex].isCancer === true &&
            this.dataModel[this.selfindex].cancerConditions.length === 0
          ) {
            this.snackbar = true;
            this.errorText = "Please select a cancer condition";
            return;
          } else {
            this.step++;
            return;
          }
        default:
          this.step++;
          return;
      }
    },
    sendResult() {
      this.saveDatatoDB()
    }
  },
  mounted() {
    this.formType === "patient" ? this.formTypeName = ["your","you","Have you","","do you have"] : ""
    this.$route.params.id ?  this.formID = this.$route.params.id:
    this.formID = this.genID()
    this.momindex = this.dataModel.findIndex(m => m.relationship === "mom");
    this.maternalGrandfatherIndex = this.dataModel.findIndex(
      m => m.relationship === "maternal grandfather"
    );
    this.maternalGrandmotherIndex = this.dataModel.findIndex(
      m => m.relationship === "maternal grandmother"
    );
    this.paternalGrandfatherIndex = this.dataModel.findIndex(
      m => m.relationship === "paternal grandfather"
    );
    this.paternalGrandmotherIndex = this.dataModel.findIndex(
      m => m.relationship === "paternal grandmother"
    );
    this.dadindex = this.dataModel.findIndex(m => m.relationship === "dad");
    this.selfindex = this.dataModel.findIndex(i => i.relationship === "self");
  },
  computed: {
    ...mapFields("patientQuestion", [
      "formValid",
      "dataModel",
      "snackbar",
      "errorText",
      "genderList",
      "formID"
    ]),
    ...mapFields(["user","snackBarType","snackBarshow","snackBarmessage"]),
    buttonText() {
      switch (this.step) {
        case this.finalStep - 2:
          return "Review";
        case this.finalStep - 1:
          return "Complete";
        default:
          return "Next";
      }
    },
    progressColor() {
      if (this.step === this.finalStep) {
        return "green";
      }
      return "blue";
    },
    progress() {
      return (this.step / this.finalStep) * 100;
    },
    currentTitle() {
      switch (this.step) {
        case 2:
          return "What is "+this.formTypeName[0] +" name?";
        case 3:
          return this.formTypeName[0] +" gender";
        case 4:
          return this.formTypeName[3] +" currently living?";
        case 5:
          if (this.dataModel[this.selfindex].isLiving) {
            return "What is "+this.formTypeName[0] +" age?";
          } else {
            return "What is "+this.formTypeName[0] +" age at passing?";
          }
        case 8:
          return "Notes (optional).";
        case this.cancerStep:
          return this.formTypeName[2] +" ever been diagnosed with cancer?";
        case this.chilStep:
          return "How many children "+ this.formTypeName[4];
        case this.geneTestStep:
          return this.formTypeName[2]+" completed any genetic testing previously?";
        case this.sibStep:
          return "How many sibling "+ this.formTypeName[4];
        case this.sibStep+1 : 
          return "How many nieces and/or nephews "+ this.formTypeName[4];
          case this.sibStep+4 : 
          return "How many maternal aunts(mother's sisters) "+ this.formTypeName[4];
          case this.sibStep+5 : 
          return "How many maternal uncles(mother's brothers) "+ this.formTypeName[4];
          case this.sibStep+11 : 
          return "How many paternal aunts(father's sisters) "+ this.formTypeName[4];
           case this.sibStep+12 : 
          return "How many paternal uncles(father's brothers) "+ this.formTypeName[4];
          case this.sibStep+6 : 
          return "How many maternal cousins "+ this.formTypeName[4];
           case this.sibStep+13 : 
          return "How many paternal cousins "+ this.formTypeName[4];
           case this.finalStep-1:
             this.complete = true
          return "";

        case this.finalStep:
          this.sendResult();
          return "Complete";
        default:
          return "";
      }
    }
  }
};
</script>
